import * as React from 'react';
import PropTypes from 'prop-types';

import { PrimaryCta } from 'components/Buttons';
import {
  NotificationModal,
  useOpenNotificationModal,
  useCloseNotificationModal
} from 'catering/components/Modals';

function LocationChangeNotificationModal({ onConfirmation }) {
  const close = useCloseNotificationModal();

  const handlePrimaryCtaClick = () => {
    onConfirmation();
    close();
  };

  return (
    <NotificationModal
      title="Uh oh! That's not an option"
      text="The items already in your cart are unavailable at the location you've
        chosen. You can continue by emptying your cart to start a new order."
    >
      <PrimaryCta
        label="Yes, empty my cart"
        handleClick={handlePrimaryCtaClick}
        fullWidth
      />
    </NotificationModal>
  );
}

LocationChangeNotificationModal.propTypes = {
  onConfirmation: PropTypes.func
};

export function useOpenLocationChangeNotificationModal() {
  return useOpenNotificationModal(<LocationChangeNotificationModal />);
}
